module.exports = __webpack_public_path__ + "assets/img/AIF-Social-Static-Ad.951fe0a9.png";